if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
        super();
        this.productHandle = this.dataset.productHandle;
        this.locale = this.dataset.locale || false;
        this.recentlyViewed = [];
        this.filteredProducts = [];
    }

    connectedCallback() {
      this.updateLocalStorage();
      if (!this.recentlyViewed) return;

      this.populateRecentlyViewed();
    }

    async populateRecentlyViewed() {                
      for (let i = 0; i < this.recentlyViewed?.length; i++) {
        const productHandle = this.recentlyViewed[i];
        if (i > 8 || !productHandle) break;
        
        if (productHandle !== this.productHandle) {
          await fetch(`/products/${productHandle}.json`)
            .then((response) => {
              if (!response.ok) return;
              return response.json();
            })
            .then((data) => {
              const product = data?.product;
              if (!product) return;
              const tags = product.tags.split(',').map(item => item.trim())
              const bannedtags = ['hide-product']
                          
              if (!bannedtags.some(i => tags.includes(i))) this.filteredProducts.push(product.handle);
            })
            .catch((err) => console.error(`Recently Viewed Products Module: ${err}`));
        }
      }
      
      if (!this.filteredProducts.length) {
        this.closest('.shopify-section')?.remove();
        return;
      }
      
      this.innerHTML = `
        <div class="page-width !sp-py-5">
          <h2 class="recommendations__heading eyebrow eyebrow--medium" style="margin-bottom: 2rem;">${window.Resources?.recentlyViewed?.heading || 'Recently Viewed'}</h2>
          <swiper-container init="false">
            ${this.filteredProducts.map(product => `
              <swiper-slide>
                <intersection-loader
                  class="sp-block sp-aspect-[249/367] sp-w-full"
                  data-url="${this.locale ? `/${this.locale}` : ''}/products/${product}"
                  data-section-id="product-tile">
                </intersection-loader>
              </swiper-slide>
            `).join('')}
          </swiper-container>
        </div>
      `;

      const swiperEl = this.querySelector('swiper-container');
      Object.assign(swiperEl, {
        slidesPerView: 2.25,
        slidesPerGroup: 2,
        rewind: true,
        spaceBetween: 20,
        breakpoints: {
          990: {
            slidesPerView: 4.25,
            spaceBetween: 20,
            slidesPerGroup: 4
          },
        },
        pagination: { clickable: true },
        navigation: true,
        injectStyles: [`
          .swiper {
            padding: 2px;
            padding-bottom: 3.5rem;
          }
          .swiper-pagination {
            bottom: 1rem !important;
          }
          .swiper-pagination-bullet {
            width: 3.8rem;
            height: .4rem;
            background: #D9D9D9;
            border-radius: 0;
            opacity: 1;
            margin: 0 .5rem;
          }
          .swiper-pagination-bullet-active {
            background: #000;
          }
          .swiper-button-prev,
          .swiper-button-next {
            display: none;
          }
          .swiper:has(.swiper-button-prev.swiper-button-disabled):has(.swiper-button-next.swiper-button-disabled) .swiper-button-prev,
          .swiper:has(.swiper-button-prev.swiper-button-disabled):has(.swiper-button-next.swiper-button-disabled) .swiper-button-next {
            display: none !important;
          }
          @media (min-width: 750px) {
            .swiper {
              padding: 2px;
              padding-bottom: 7.3rem;
            }
            .swiper-pagination {
              bottom: 2.2rem;
            }
            .swiper-button-prev,
            .swiper-button-next {
              display: flex;
              top: auto;
              bottom: 1.2rem;
              width: 2.4rem;
              height: 2.4rem;
              margin-top: 0;
              --swiper-navigation-color: #000;
              --swiper-navigation-size: 1.2rem;
              z-index: 11;
            }
            .swiper-button-prev {
              left: auto;
              right: calc(50% + 7rem);
            }
            .swiper-button-next {
              right: auto;
              left: calc(50% + 7rem);
            }
          }
        `],
      });
      swiperEl.initialize();

      let equalizeTimer;
      const equalizeHeights = () => {
        const tiles = [...this.querySelectorAll('product-tile')];
        if (!tiles.length) return;
        tiles.forEach(t => t.style.height = '');
        requestAnimationFrame(() => {
          const maxH = Math.max(...tiles.map(t => t.getBoundingClientRect().height));
          if (maxH <= 0) return;
          tiles.forEach(t => t.style.height = `${maxH}px`);
        });
      };

      const heightObserver = new MutationObserver(() => {
        clearTimeout(equalizeTimer);
        equalizeTimer = setTimeout(equalizeHeights, 50);
      });
      heightObserver.observe(this, { childList: true, subtree: true });
    }

    updateLocalStorage() {
      if (localStorage.getItem('sf:recentlyViewedProducts')) {
        this.recentlyViewed = [...new Set([...localStorage.getItem('sf:recentlyViewedProducts')?.split(',')])].slice(0, 8) ?? [];
      }

      if ((this.recentlyViewed[this.productHandle]) || !this.productHandle) return;
      localStorage.setItem('sf:recentlyViewedProducts', `${this.productHandle}${this.recentlyViewed ? `,${this.recentlyViewed}` : ''}`);
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}